import { Button, HStack, Stack } from '@chakra-ui/react'
import React from 'react'
import { Link } from 'react-router-dom'

const Portalbutton = () => {
  return (
    <Stack direction={['column','row']} spacing={8} w={'full'} mt={['20vh','25vh']}  h={'70vh'} justifyContent={'center'} alignItems={'center'}>
<Link to="/login-admin">
<Button variant={'solid'} px={20} rounded={'full'} py={8} colorScheme={'orange'}>Admin Login</Button>
</Link>
<Link to="/login-clerk">
<Button variant={'outline'}  rounded={'full'} px={20} py={8}>Clerk Login</Button>
</Link>
    </Stack>
  )
}

export default Portalbutton
